/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const user = {
    // 获取用户中心信息    
    getUserCenterInfo(params) {
        return axios.post('/goods/mobileUser/getUserCenterInfo', qs.stringify(params));
    },
    //用户登录
    login(params) {
        return axios.post('/goods/mobileUser/login', qs.stringify(params));
    },
    //修改密码
    changeUserPwd(params) {
        return axios.post('/goods/mobileUser/changeUserPwd', qs.stringify(params));
    },
    //获取用户收货地址列表信息
    getUserReceivAddr(params) {
        return axios.post('/goods/mobileUser/getUserReceivAddr', qs.stringify(params));
    },
    //修改或新增用户收货地址信息
    addOrUpdateUserReceivAddr(params) {
        return axios.post('/goods/mobileUser/addOrUpdateUserReceivAddr', qs.stringify(params));
    },
    //修改或新增用户收货地址信息
    addOrUpdateUserReceivAddrDock(params) {
        return axios.post('/goods/mobileUser/addOrUpdateUserReceivAddr_dock', qs.stringify(params));
    },
    //获取用户信息
    getUserInfo(params) {
        return axios.post('/goods/mobileUser/getUserInfo', qs.stringify(params));
    },
    getWechatSign(params) {
        return axios.post('/goods/mobileUser/getWechatSign', qs.stringify(params));
    },
    //获取所有公告信息
    getAllNotice(params) {
        return axios.post('/goods/mobileUser/getAllNotice', qs.stringify(params));
    },
    //获取所有图片信息
    getAllMobilePic(params) {
        return axios.post('/goods/mobileUser/getAllMobilePic', qs.stringify(params));
    },
    //注册用户
    registerUser(params) {
        return axios.post('/order/user/register', qs.stringify(params));
    },
    //注册用户通过企业id获取企业信息
    getCompanyInfoById(params) {
        return axios.post('/order/user/getCompanyInfoById', qs.stringify(params));
    },
    //获取系统配置（对接）
    getSysConfig(params) {
        return axios.post('/order/sysConfig/getSysConfig', qs.stringify(params));
    },
    //生成业务员对应的邀请码
    getUrlQrcode(params) {
        return axios.post('/order/fpDirtribution/getUrlQrcode', qs.stringify(params));
    },
    //获取业务员的邀请码信息
    getInviteQrcode(params) {
        return axios.post('/order/fpDirtribution/getInviteQrcode', qs.stringify(params));
    },
    updateLoginNum(params) {
        return axios.post('/order/user/updateLoginNum', qs.stringify(params));
    },
    //校验业务码是否存在
    verifyBusinessCode(params) {
        return axios.post('/order/user/verifyBusinessCode', qs.stringify(params));
    },
    getActivityStoredList(params) {
        return axios.post('/order/activityStored/getActivityStoredList', qs.stringify(params));
    },
    getRechargeRecord(params) {
        return axios.post('/goods/mobileUser/getRechargeRecord', qs.stringify(params));
    },
    //获取用户是否已登录
    getUserIsLogined(params) {
        return axios.post('/goods/mobileUser/getUserIsLogined', qs.stringify(params));
    },
    //客户退出登录修改客户是否已登录状态
    logout(params) {
        return axios.post('/goods/mobileUser/logout', qs.stringify(params));
    },
    //独立版获取储值信息
    getMobileUserStoredInfoAlone(params) {
        return axios.post('/order/mobileStoredAlone/getMobileUserStoredInfoAlone', qs.stringify(params));
    },
    //独立版储值获取充值记录
    getMobilePayStoredRecordAlone(params) {
        return axios.post('/order/mobileStoredAlone/getMobilePayStoredRecordAlone', qs.stringify(params));
    },
    //判断用户是否开启储值支付
    getUserParMethodAlone(params) {
        return axios.post('/order/mobileStoredAlone/getUserParMethodAlone', qs.stringify(params));
    },
    //独立版判断客户是否已经删除
    getUserInfoAloneStatus(params) {
        return axios.post('/goods/mobileUserAlone/getUserInfoAloneStatus', qs.stringify(params));
    },
    getContainerDetailInfoAlone(params) {
        return axios.post('/goods/containerAlone/getContainerDetailInfoAlone', qs.stringify(params));
    },
    //删除用户地址
    deleteUserReceiveAddr(params) {
        return axios.post('/goods/mobileUser/deleteUserReceiveAddr', qs.stringify(params));
    },
    //获取微信公众号认证信息
    getWxPublicAuthInfo(params) {
        return axios.post('/order/wxPublicInfo/getWxPublicAuthInfo', qs.stringify(params));
    },
    //根据授权后获取的code获取oPenId（客户和公众号的唯一ID）
    bandWxPublicAuthOpenId(params) {
        return axios.post('/order/wxPublicInfo/bandWxPublicAuthOpenId', qs.stringify(params));
    },
    //获取消息通知页面信息
    getWxPublicInfo(params) {
        return axios.post('/order/wxPublicInfo/getWxPublicInfo', qs.stringify(params));
    },
    //启用/停用绑定关系的模板联系
    enableWxPublicUserRelationInfo(params) {
        return axios.post('/order/wxPublicInfo/enableWxPublicUserRelationInfo', qs.stringify(params));
    },
    //解绑公众号信息
    unbindBandWxPublicAuthOpenId(params) {
        return axios.post('/order/wxPublicInfo/unbindBandWxPublicAuthOpenId', qs.stringify(params));
    },
    //订货端根据分拣单号获取容器信息
    getContainerInfoListAlone(params) {
        return axios.post('/order/container/getContainerInfoListAlone', qs.stringify(params));
    },
    //订货端验收容器商品信息
    checkingContainerGoodsInfoAlone(params) {
        return axios.post('/order/container/checkingContainerGoodsInfoAlone', qs.stringify(params));
    },
    //订货端一键验收容器商品信息
    oneClickCheckingContainerGoodsInfoAlone(params) {
        return axios.post('/order/container/oneClickCheckingContainerGoodsInfoAlone', qs.stringify(params));
    },
    //订货端提交验收容器信息
    submitCheckingContainerInfoAlone(params) {
        return axios.post('/order/container/submitCheckingContainerInfoAlone', qs.stringify(params));
    },
    //订货端取消验收容器信息
    cancelCheckingContainerInfoAlone(params) {
        return axios.post('/order/container/cancelCheckingContainerInfoAlone', qs.stringify(params));
    },
}

export default user;


// WEBPACK FOOTER //
// ./src/request/api/user/user.js